import React, { useEffect, useState } from "react";
import { get_stripe_session_link } from "../../services/api/Subscriptions";

export default function RedirectToStripe() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function redirect() {
        try {
            const redirectUrl = 'https://doitforme.eu/';
            const url = await get_stripe_session_link(redirectUrl);
            if (!url) {
                console.error("Failed to generate session link");
                setLoading(false);
                return;
            }
            window.location.href = url;
        } catch (err) {
            console.error("Unexpected error generating session link", err);
            setLoading(false);
        }
    }

    redirect();
  }, []);

const spinnerStyle = {
    width: "50px",
    height: "50px",
    border: "5px solid #3498db",
    borderTop: "5px solid transparent",
    borderRadius: "50%",
    animation: "spin 1s linear infinite",
  };

  return (
    <div style={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      minHeight: "100vh",
      backgroundColor: "#f5f5f5",
      flexDirection: "column",
      textAlign: "center",
      fontFamily: "Arial, sans-serif"
    }}>
      {loading ? (
        <>
          <div style={spinnerStyle}></div>
          <p style={{ marginTop: "20px", fontSize: "18px", color: "#333" }}>
            Redirecting you to Stripe...
          </p>
        </>
      ) : (
        <p style={{ color: "red", fontSize: "18px" }}>
          Failed to load payment session. Please try again.
        </p>
      )}
      {/* CSS keyframes for spinner */}
      <style>{`
        @keyframes spin {
          0% { transform: rotate(0deg);}
          100% { transform: rotate(360deg);}
        }
      `}</style>
    </div>
  );
}
